import { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "@/lib/firebase";

export default function ResultadoAvatarPage() {
  const [avatares, setAvatares] = useState<string[]>([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const carregar = async () => {
      try {
        const q = query(collection(db, "avatares"), orderBy("criadoEm", "desc"));
        const snap = await getDocs(q);
        setAvatares(snap.docs.map((d) => d.data().imageBase64 as string));
      } catch {
        setAvatares([]);
      } finally {
        setCarregando(false);
      }
    };
    carregar();
  }, []);

  return (
    <div
      className="min-h-screen px-4 py-16"
      style={{
        backgroundColor: "#DA422F",
        backgroundImage: "url(/images/bg-evento.png)",
        backgroundSize: "cover",
        backgroundPosition: "center top",
        fontFamily: "var(--font-oswald)",
      }}
    >
      <div className="max-w-4xl mx-auto">
        {/* Cabeçalho */}
        <div className="text-center mb-12 space-y-2">
          <p className="text-xs tracking-[0.4em] uppercase" style={{ color: "#F8EBC1" }}>
            DU NADA
          </p>
          <h1
            className="text-4xl md:text-6xl font-bold uppercase leading-tight"
            style={{ color: "#F8EBC1" }}
          >
            Avatares criados
          </h1>
          {!carregando && (
            <p className="text-sm opacity-60 uppercase tracking-widest" style={{ color: "#F8EBC1" }}>
              {avatares.length} avatar{avatares.length !== 1 ? "es" : ""}
            </p>
          )}
        </div>

        {/* Loading */}
        {carregando && (
          <div className="flex justify-center py-20">
            <div
              className="animate-spin rounded-full border-8"
              style={{
                width: "72px",
                height: "72px",
                borderColor: "#F8EBC1",
                borderTopColor: "transparent",
              }}
            />
          </div>
        )}

        {/* Vazio */}
        {!carregando && avatares.length === 0 && (
          <p
            className="text-center text-2xl font-bold uppercase opacity-40 py-20"
            style={{ color: "#F8EBC1" }}
          >
            Nenhum avatar ainda
          </p>
        )}

        {/* Grid */}
        {!carregando && avatares.length > 0 && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {avatares.map((url, i) => (
              <img
                key={i}
                src={url}
                alt={`Avatar ${i + 1}`}
                className="w-full rounded-full object-cover aspect-square"
                style={{ border: "3px solid #F8EBC133" }}
                loading="lazy"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
